import {
  IteratorInfo,
  TranslatorInfo,
  RedactionInfo,
  ChatBotInfo,
  SupplierDemandConstantsInfo,
} from "./aiToolkitInfo";

import IteratorIcon from "@mui/icons-material/Autorenew";
import TranslationIcon from "@mui/icons-material/Translate";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";

// Define the modules for ai toolkit
export const getModules = (accountInfo) => {
  if (!accountInfo) return [];

  const modules = [];
  if (accountInfo.showIterator) {
    modules.push({
      name: "Iterator",
      path: "/AiToolkit/Iterator",
      icon: IteratorIcon,
      popoverContent: IteratorInfo(),
      buttonLabel: "view tool",
    });
  }
  if (accountInfo.showRedaction) {
    modules.push({
      name: "Redaction",
      path: "/AiToolkit/Redaction",
      icon: VisibilityOffOutlinedIcon,
      popoverContent: RedactionInfo(),
      buttonLabel: "view tool",
    });
  }
  if (accountInfo.showTranslator) {
    modules.push({
      name: "Translator",
      path: "/AiToolkit/Translator",
      icon: TranslationIcon,
      popoverContent: TranslatorInfo(),
      buttonLabel: "view tool",
    });
  }
  if (accountInfo.showSupplierDemandConstants) {
    modules.push({
      name: "Supplier Demand Constants",
      path: "/AiToolkit/Supplier_Demand_Constants",
      icon: AssessmentOutlinedIcon,
      popoverContent: SupplierDemandConstantsInfo(),
      buttonLabel: "view tool",
    });
  }
  if (accountInfo.showChatBot) {
    modules.push({
      name: "Chat Box Investigator",
      path: "*",
      icon: ChatOutlinedIcon,
      popoverContent: ChatBotInfo(),
      buttonLabel: "view tool",
    });
  }
  return modules;
};

// Navbar
// Filter navigation items based on account
export const getFilteredNavigationItems = (accountInfo) => {
  if (!accountInfo) return [];

  // Items that don't change for any accocunt ‼️‼️ Create a separate file for these maybe navigation in utils
  const baseItems = [
    { label: "Home Page", path: "/Home" },
    { label: "Generate Insight", path: "/GenerateInsights" },
  ];

  // Adding Generate Supplier if account is allowed
  if (accountInfo.showSupplierFinder) {
    baseItems.push({
      label: "Generate Supplier",
      path: "/GenerateSuppliers",
    });
  }

  // Adding AI toolkit if account is allowed
  if (accountInfo.showAIToolkit) {
    const aiToolkitChildren = [];
    if (accountInfo.showIterator) {
      aiToolkitChildren.push({
        label: "Iterator",
        path: "/AiToolkit/Iterator",
      });
    }
    if (accountInfo.showRedaction) {
      aiToolkitChildren.push({
        label: "Redaction",
        path: "/AiToolkit/Redaction",
      });
    }
    if (accountInfo.showTranslator) {
      aiToolkitChildren.push({
        label: "Translation",
        path: "/AiToolkit/Translator",
      });
    }
    if (accountInfo.showChatBot) {
      aiToolkitChildren.push({
        label: "ChatBot",
        path: "*",
      });
    }
    if (accountInfo.showSupplierDemandConstants) {
      aiToolkitChildren.push({
        label: "Supplier Demand Constants",
        path: "/AiToolkit/Supplier_Demand_Constants",
      });
      // Keep in the data so NavBar can resolve titles for these routes, but excluded from the visible AI Toolkit dropdown via hideInNav.
      aiToolkitChildren.push({
        label: "Supply Constants",
        path: "/AiToolkit/Supply_Constants",
        hideInNav: true,
      });
      aiToolkitChildren.push({
        label: "Demand Constants",
        path: "/AiToolkit/Demand_Constants",
        hideInNav: true,
      });
    }
    // Add AI toolkit if it has at least one child
    if (aiToolkitChildren.length > 0) {
      baseItems.push({
        label: "AI Toolkit",
        path: "/AiToolkit",
        children: aiToolkitChildren,
      });
    }
  }
  return baseItems;
};
